import { STATUS } from '../../data/site';
import OverviewWindow from './windows/OverviewWindow';
import TillWindow from './windows/TillWindow';
import LedgerWindow from './windows/LedgerWindow';
import OrderWindow from './windows/OrderWindow';
import TripsWindow from './windows/TripsWindow';

/**
 * Dispatches to the right product-view layout.
 *
 * Each layout is a genuinely different screen, a till, a ledger, an order
 * book, a dispatch board, because four dashboards built from the same
 * template read as one screenshot repeated, which is exactly the problem this
 * replaced. Pass `layout` in the data (see src/data/site.js) and the caller
 * never has to know which layout it is.
 *
 * `tone` decides the surface: 'dark' on the dark shell, 'light' on light
 * pages, so light mode stays light and dark mode stays dark.
 */
const LAYOUTS = {
  overview: OverviewWindow,
  till: TillWindow,
  ledger: LedgerWindow,
  order: OrderWindow,
  trips: TripsWindow,
};

export default function AppWindow({ layout = 'overview', tone = 'dark', note, ...rest }) {
  const Layout = LAYOUTS[layout] || OverviewWindow;
  return (
    <Layout data-component-id="src/components/product/AppWindow.jsx:31:4" data-component-path="src/components/product/AppWindow.jsx" data-component-line="31" data-component-end-line="35" data-component-file="AppWindow.jsx" data-component-name="Layout" data-component-content="%7B%22elementName%22%3A%22Layout%22%2C%22%5Bspread%5D%22%3A%22true%22%7D"
      tone={tone}
      note={note === undefined ? STATUS.figuresNote : note}
      {...rest}
    />
  );
}
